import { Pipe, PipeTransform } from '@angular/core';
import { AccountingResult, AccountingSystem } from '@jms/model';

type AccountingResultLike = AccountingResult | { success: boolean, type: string, integrationInvoiceId: string };

@Pipe({
  name: 'accountingIntegrationIcon',
  standalone: true,
})
export class AccountingIntegrationIconPipe implements PipeTransform {

  transform(integration: AccountingResultLike): string {

    if (!integration) return null;

    switch (integration.type) {

      case AccountingSystem.Xero: {
        return integration.success
          ? '/images/accounting/logo-xero-blue.svg'
          : '/images/accounting/logo-xero-red.svg';
      }

      case AccountingSystem.MYOB: {
        return integration.success
          ? '/images/accounting/logo-myob-only.svg'
          : '/images/accounting/logo-myob-only-red.svg';
      }

      case AccountingSystem.QuickBooks: {
        return integration.success
          ? '/images/accounting/logo-quickbooks.svg'
          : '/images/accounting/logo-quickbooks-red.svg';
      }

      default: {

        return null;
      }

    }

  }

}
